<!-- 本地之星 box -->
<template>
    <div class="local-star-box">
        本地之星
        <img
            ref="local-star-tip"
            class="icon"
            src="@/assets/img/law/question.svg"
            alt=""
        />
        <div class="number">
            <span class="info-msg-num-value">
                权益生效中
            </span>
        </div>
        <veui-popover
            target="local-star-tip"
            position="bottom-center"
        >
            <span class="help-text">本地之星律所享受权益城市的案源不限次认领和推荐位独占曝光权益</span>
        </veui-popover>
        <div
            class="city"
            :class="{'mult': localStarInfo.length > 1}"
            :ref="localStarInfo.length > 1 ? 'city' : ''"
        >
            <span v-for="item, index in localStarInfo" :key="index">
                {{ item.city }}
                <template v-if="index !== localStarInfo.length - 1">、</template>
            </span>
            <!-- 单个城市 -->
            <span v-if="localStarInfo && localStarInfo.length === 1" class="validity-data">{{ localStarInfo[0].validity_end }}失效</span>
            <!-- 多个城市 -->
            <img
                v-else
                class="right-arrow"
                src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-clues/right-arrow.png"/>
        </div>
        
        <!-- 多个城市 -->
        <veui-popover
            target="city"
            position="bottom-center"
            trigger="click"
        >
            <p class="help-text" v-for="item, index in localStarInfo" :key="index">
                {{ item.city }}: {{ item.validity_end }}失效
            </p>
        </veui-popover>
    </div>
</template>

<script>
import {Popover} from 'veui';
export default {
    components: {
        'veui-popover': Popover
    },
    props: {
        // 本地之星数据
        localStarInfo: {
            type: Array,
            default() {
                return [];
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
.local-star-box
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #333;
    line-height: 14px;
    .icon
        width: 14px;
        height: 14px;
        margin-left: 3px;
        vertical-align: bottom;
        cursor: pointer;
.number
    font-family: HelveticaNeue-Bold;
    font-size: 28px;
    color: #282c33;
    line-height: 28px;
    font-weight: 700;
    margin-top: 8px;
.city
    font-size: 12px;
    color: #333333;
    line-height: 14px;
    margin-top: 10px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    position: relative;
    padding-right: 12px;

    &.mult
        cursor: pointer;
    .validity-data
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        line-height: 14px;
        margin-left: 8px;
    .right-arrow
        height: 10px;
        width: 8px;
        position: absolute;
        right: 0;
        top: 2px;
</style>
